export const formatAddressFilter = (object) => {
	if (object) {
		return (
			object.address +
			(object.address_line_2 ? '(' + object.address_line_2 + ')' : '') +
			' - ' +
			object.city +
			(object.province ? ' (' + object.province.code + ')' : '') +
			' - ' +
			object.country_id
		)
	}
}



// WEBPACK FOOTER //
// ./src/utils/filters/formatAddress.js